import { render, staticRenderFns } from "./RegionSectionPlaceholder.vue?vue&type=template&id=61f1bf28&scoped=true"
import script from "./RegionSectionPlaceholder.vue?vue&type=script&lang=js"
export * from "./RegionSectionPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./RegionSectionPlaceholder.vue?vue&type=style&index=0&id=61f1bf28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f1bf28",
  null
  
)

export default component.exports